import * as React from 'react'

import {LabelCountry} from "@components";

export default function retailerColumn() {
	return {
		name: 'retailer', label: 'Retailer',
		options: {
			customBodyRowRender: (value, { country }) => {
				return <LabelCountry country={country} label={value} />
			}
		}
	}
}